'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var GENDERS = exports.GENDERS = {
  F: { text: 'Female', key: 'F' },
  M: { text: 'Male', key: 'M' },
  U: { text: 'Unknown', key: 'U' }
};

var happy = exports.happy = 1;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/utils/constants.js
 ** module id = 976
 ** module chunks = 0
 **/